"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "form-page" };
const _hoisted_2 = { class: "form-data-container" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "row-head" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "ALAPADATOK")
], -1);
const _hoisted_5 = { class: "inputs" };
const _hoisted_6 = { class: "multiple-inputs" };
const _hoisted_7 = { class: "multiple-inputs" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "row-head" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "ELÉRHETŐSÉG")
], -1);
const _hoisted_10 = { class: "inputs" };
const _hoisted_11 = { class: "multiple-inputs address" };
const _hoisted_12 = { class: "multiple-inputs" };
const _hoisted_13 = { class: "row" };
const _hoisted_14 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "row-head" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "GEOLOKÁCIÓ")
], -1);
const _hoisted_15 = { class: "inputs" };
const _hoisted_16 = { class: "column" };
const _hoisted_17 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "column" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("iframe", {
        width: "100%",
        height: "100%",
        frameborder: "0",
        scrolling: "no",
        marginheight: "0",
        marginwidth: "0",
        src: "https://www.openstreetmap.org/export/embed.html?bbox=18.51402282714844%2C47.287613425713516%2C19.42039489746094%2C47.76332998647307&layer=mapnik",
        style: { "border": "1px solid black" }
    }),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("small", null, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("a", { href: "https://www.openstreetmap.org/#map=11/47.5260/18.9672" }, "Nagyobb térkép")
    ])
], -1);
const Form_1 = require("../../../../components/Form");
const CustomTextArea_vue_1 = __importDefault(require("../../../../components/backend/CustomTextArea.vue"));
const CustomFileInput_vue_1 = __importDefault(require("../../../../components/backend/CustomFileInput.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'LocationFormData',
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        _hoisted_4,
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                name: "service_name",
                                label: "Szerviz neve"
                            }),
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    name: "perma",
                                    label: "Permalink"
                                }),
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    name: "vat_num",
                                    label: "Adószám"
                                }),
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    name: "ic",
                                    label: "Cégjegyzékszám"
                                })
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                (0, vue_2.createVNode)(CustomTextArea_vue_1.default, {
                                    label: "Bemutatkozás",
                                    name: "bemutatkozas",
                                    rows: 6
                                }),
                                (0, vue_2.createVNode)(CustomFileInput_vue_1.default, {
                                    label: "Képek",
                                    type: "image",
                                    text: "KÉP FELTÖLTÉSE Feltöltési korlát: 2 Mb"
                                })
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        _hoisted_9,
                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                            (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    class: "zip",
                                    name: "zip",
                                    label: "Irányítószám"
                                }),
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    class: "city",
                                    name: "city",
                                    label: "Város"
                                }),
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    class: "address",
                                    name: "address",
                                    label: "Cím"
                                })
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    name: "tel1",
                                    label: "Telefonszám #1"
                                }),
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    name: "tel2",
                                    label: "Telefonszám #2"
                                }),
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    name: "email",
                                    label: "Email"
                                })
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_13, [
                        _hoisted_14,
                        (0, vue_2.createElementVNode)("div", _hoisted_15, [
                            (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    name: "search_address",
                                    label: "Cím keresés"
                                }),
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    name: "lat",
                                    label: "Földrajzi szélesség"
                                }),
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    name: "lon",
                                    label: "Földrajzi hosszúság"
                                }),
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    name: "same_address",
                                    label: "Egyező cím"
                                })
                            ]),
                            _hoisted_17
                        ])
                    ])
                ])
            ]));
        };
    }
});
